import { calculatePasswordStrength } from "@/utils/passwordStrength";
import { Progress } from "@/components/ui/progress";

interface PasswordStrengthIndicatorProps {
  password: string;
}

export const PasswordStrengthIndicator = ({ password }: PasswordStrengthIndicatorProps) => {
  const strength = calculatePasswordStrength(password);
  
  if (!password) return null;

  const progressValue = (strength.score / 4) * 100;
  
  const colorClasses = {
    destructive: 'text-destructive',
    warning: 'text-amber-500',
    success: 'text-green-600',
  };

  return (
    <div className="space-y-2">
      <Progress 
        value={progressValue} 
        className="h-1.5"
      />
      <p className={`text-xs font-medium ${colorClasses[strength.color]}`}>
        {strength.feedback}
      </p>
    </div>
  );
};
